/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ComputeView.vue?vue&type=template&id=496dfe68&scoped=true"
import script from "./ComputeView.vue?vue&type=script&lang=js"
export * from "./ComputeView.vue?vue&type=script&lang=js"
import style0 from "./ComputeView.vue?vue&type=style&index=0&id=496dfe68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496dfe68",
  null
  
)

export default component.exports